/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type PropsWithChildren, createContext, useContext } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import environmentConfig from '@/config/environment';
import { useLocale } from '@/hooks/useLocale';

const MapsApiMountedContext = createContext(false);

export function PlacesApiProvider({ children }: PropsWithChildren) {
  const alreadyMounted = useContext(MapsApiMountedContext);
  const apiKey = environmentConfig.GOOGLE_MAPS_API_KEY;
  const locale = useLocale();

  const [language, region] = locale.split('-');

  if (!apiKey || alreadyMounted) {
    return <>{children}</>;
  }

  return (
    <MapsApiMountedContext.Provider value={true}>
      <APIProvider
        apiKey={apiKey}
        libraries={['places', 'geocoding']}
        language={language}
        region={region}
      >
        {children}
      </APIProvider>
    </MapsApiMountedContext.Provider>
  );
}
